import CloseIcon from 'app/ui_v2/icons/CloseIcon';
import { useRef } from 'react';
import Draggable from 'react-draggable';

import { Box, IconButton, Pagination, Paper, PaperProps } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import ButtonLoader from '../button-loader/ButtonLoader';

export interface DataDialogProps {
  children: any;
  open: boolean;
  isLoading: boolean;
  isDraggable?: boolean;
  title: string;
  onCancel?: () => void;
  onAction?: () => void;
  onPageChange?: (page: string) => void;
  cancelButtonText?: string;
  actionButtonText?: string;
  isWithClosingIcon?: boolean;
  totalPages?: number;
  currentPage?: number;
  handleCancelWithClosingIcon?: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

function PaperComponent(props: PaperProps) {
  const nodeRef = useRef(null);
  return (
    <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

export default function DataDialog(props: DataDialogProps) {
  const {
    open,
    onCancel,
    children,
    isLoading,
    title,
    onAction,
    onPageChange,
    cancelButtonText = 'Cancel',
    actionButtonText = 'Submit',
    isDraggable = false,
    handleCancelWithClosingIcon,
    totalPages,
    currentPage,
    maxWidth = 'lg',
  } = props;

  const handleCancel = () => {
    onCancel && onCancel();
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange && onPageChange(String(value));
  };

  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={true}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperComponent={isDraggable ? PaperComponent : undefined}
    >
      <DialogTitle
        style={{
          cursor: isDraggable ? 'move' : 'default',
          fontSize: '2.8rem',
          fontWeight: 'bold',
        }}
        id="draggable-dialog-title"
      >
        {title}

        {handleCancelWithClosingIcon && (
          <IconButton
            aria-label="close"
            onClick={() => handleCancelWithClosingIcon()}
            style={{ position: 'absolute', top: '18px', right: '15px', color: ' ' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>

      <DialogActions disableSpacing>
        {onPageChange && totalPages && totalPages > 1 && (
          <Box display="flex" flex="1">
            <Pagination count={totalPages} page={currentPage} onChange={handleChange} />
          </Box>
        )}
        {onCancel && (
          <Box mr={2}>
            <Button
              variant="outlined"
              disabled={isLoading}
              onClick={() => {
                onCancel && onCancel();
              }}
              autoFocus
            >
              {cancelButtonText}
            </Button>
          </Box>
        )}
        {onAction && (
          <Button
            color="primary"
            disableElevation
            variant="contained"
            disabled={isLoading}
            onClick={() => {
              onAction && onAction();
            }}
          >
            <ButtonLoader isActive={isLoading} noMargin={false} />
            {actionButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
